import { Link } from 'react-router-dom';
import { Settings } from 'lucide-react';
import { Button } from '@/components/ui';

interface ManageBarButtonProps {
  barId: string;
}

export function ManageBarButton({ barId }: ManageBarButtonProps) {
  return (
    <Link to={`/admin/bars/${barId}`} className="block mt-2">
      <Button variant="secondary" className="w-full flex items-center justify-center gap-2">
        <Settings className="h-4 w-4" />
        Manage This Bar
      </Button>
    </Link>
  );
}
